/* eslint-disable */
import React, { useEffect } from 'react';
import Loader from '../../components/Loaders/Loader';
import { authSuperAdmin } from '../../services/endpoints/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getErrorMessage, parseJwt } from '../../utils/helper';
import { userAuthSuperAdminSuccess, userLogoutCredentialsAction } from '../../redux/actions/user';

const PageSuperAdmin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAuth } = useSelector((state) => state.user);
  const params = useParams();

  const checkInit = async () => {
    const { token } = params;
    if (isAuth) {
      history.push({
        pathname: '/',
        search: history.location.search,
      });
      return;
    }
    try {
      const response = await authSuperAdmin({
        token
      })
      if (response?.data?.data?.access_token) {
        const jwt = parseJwt(response.data?.data?.access_token);
        if (jwt.su) {
          dispatch(userAuthSuperAdminSuccess(response.data.data.access_token))
        }
        return;
      }
      dispatch(userLogoutCredentialsAction('Access token error'))
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(userLogoutCredentialsAction(errorMessage))
    }
  }

  useEffect(() => {
    document.title = '';
    checkInit()
  }, []);

  return <Loader />

};

export default PageSuperAdmin;
